import systemConfigs from '@/configs/system/baseUrl'
import Http from '@/Apis/functions/basic/Http'

const serviceIns = new Http(systemConfigs.baseUrl ?? '/')
export default serviceIns
